<template>
  <div class="l-default">
    <Header :content="contentHeaderFooter" :isShowSupplementaryCoupon="isShowSupplementaryCoupon" :isShowCafeteriaPoint="isShowCafeteriaPoint" />

    <div class="l-container  sm:border-b breadcrumb-wrapper">
      <Breadcrumb v-if="!isPublicMenu && !hideBreadcrumb" />
    </div>
    <router-view :isShowSupplementaryCoupon="isShowSupplementaryCoupon" :isShowCafeteriaPoint="isShowCafeteriaPoint"></router-view>
    <div v-show="scY > 300" class="scrollTop">
      <button class="btn-back-to-top" @click="toTop">
        <Icon
            class="pageTop__button__icon"
            name="arrow_up"
            width="40px"
            height="40px"
          />
      </button>
    </div>
    <Footer :content="contentHeaderFooter" />
    <CommonModal />
  </div>
</template>

<script>
import { get } from 'lodash'
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import { bus } from '@/main'
import { Breadcrumb } from '@/components/compound'
export default {
  name: 'DefaultLayout',
  components: {
    Header,
    Footer,
    Breadcrumb
  },
  data() {
    return {
      scTimer: 0,
      scY: 0,
      headerNo: this.$route.meta.header,
      footerNo: this.$route.meta.footer,
      contentHeaderFooter: null,
      isPublicMenu:false,
      isShowSupplementaryCoupon: false,
      isShowCafeteriaPoint: false
    }
  },
  async created() {
    try {
      this.getData();
      const availableDataList = await this.$repositories('coupon').getSubsidyCouponList({displayDiv: "1"});
      const cafe = await this.$repositories('cafe').checkCafeAvailable();
      const avaialbleCafe = cafe.data;

      if (avaialbleCafe && avaialbleCafe === 'OK') {
        this.isShowCafeteriaPoint = true;
      }

      if (availableDataList && availableDataList.length > 0) {
        this.isShowSupplementaryCoupon = true;
      }
    } catch (error) {
      console.error('Error in created hook (Promise/async):', error);
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
    bus.$on('noPuclicDate', (val)=>{
      console.log(val)
      this.isPublicMenu = val
    })
  },
  beforeDestroy(){
    bus.$off('noPuclicDate')
  },
  methods: {
    handleScroll() {
      if (this.scTimer) return
      this.scTimer = setTimeout(() => {
        this.scY = window.scrollY
        clearTimeout(this.scTimer)
        this.scTimer = 0
      }, 100)
    },
    toTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    },
    getData() {
      this.$repositories('cms')
        .getHeaderFooter()
        .then((response) => {
          this.contentHeaderFooter = get(response, 'data')
        })
    }
  },
  watch: {
    $route() {
      this.footerNo = this.$route.meta.footer
    }
  },
  computed: {
    isSearchPage() {
      return this.$route.path === "/search/menu";
    },
    hideBreadcrumb() {
      return (
        [
          "BS_APP_02_001 申込(何を・どこに)",
          "BS_APP_02_001_NEW",
          "BS_APP_02_002 申込(誰が)",
          "BS_APP_02_002 申込(誰が) - Public stay",
          "BS_APP_02_004_NEW 補助利用申請",
          "BS_APP_02_005 申込確認",
          "BS_APP_02_005 申込確認 - Public stay",
          "BS_APP_02_006_申込完了ページ / Page hoàn tất đăng ký",
          "BS_APP_02_006_NEW",
        ].includes(this.$route.name)
      )
    }
  }
}
</script>

<style lang="scss" scoped>
@import './styles.scss';
</style>
